import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

const AdminGroupEditMembersEditSelectItem = (props) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <div className="user-item">
        {data.avatar ? (
          <div className="user-avatar">
            <img src={data.avatar} alt={data.name} className="avatar avatar-40" />
          </div>
        ) : (
          <div className="user-avatar">
            <div className="avatar avatar-40 icon-avatar gray">
              <i className="fas fa-user" />
            </div>
          </div>
        )}
        <div className="user-item-body">
          <h6 className="user-item-title">
            {data.name}
          </h6>
          {data.email && (
            <span className="user-item-details">
              {data.email}
            </span>
          )}
        </div>
      </div>
    </components.Option>
  );
};

AdminGroupEditMembersEditSelectItem.propTypes = {
  data: PropTypes.object.isRequired,
};

export default AdminGroupEditMembersEditSelectItem;
